import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "image", "video", "source", "caption"]
  static values = {
    type: String,
    url: String,
    filename: String,
    contentType: String
  }

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    this.unload()
    document.removeEventListener("keydown", this.boundKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.boundKeydown)
    this.load()
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.boundKeydown)
    this.unload()
  }

  handleBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }

  load() {
    this.captionTarget.textContent = this.filenameValue || ""

    if (this.typeValue === "image") {
      this.imageTarget.src = this.urlValue
      this.imageTarget.alt = this.filenameValue || ""
      this.imageTarget.classList.remove("hidden")
      this.videoTarget.classList.add("hidden")
    } else if (this.typeValue === "video") {
      this.sourceTarget.src = this.urlValue
      this.sourceTarget.type = this.contentTypeValue || "video/mp4"
      this.videoTarget.load()
      this.videoTarget.classList.remove("hidden")
      this.imageTarget.classList.add("hidden")
    }
  }

  unload() {
    if (this.hasImageTarget) {
      this.imageTarget.removeAttribute("src")
    }

    if (this.hasVideoTarget) {
      this.videoTarget.pause()
      this.sourceTarget.removeAttribute("src")
      this.videoTarget.load()
    }
  }
}
